// @ts-nocheck
import { BackHandler } from 'react-native';

/**
 * Polyfill for the deprecated `BackHandler.removeEventListener` API that was
 * removed in React Native 0.72+ (Expo SDK 53 / RN 0.79).  Many third-party
 * libraries – including some versions of Gluestack UI – still rely on the
 * old method-pair (`addEventListener`, `removeEventListener`).
 *
 * We re-implement a minimal compatibility layer:
 * • Wrap `BackHandler.addEventListener` so that we can keep a reference to the
 *   returned subscription for a given handler.
 * • Expose a no-op `BackHandler.removeEventListener` that looks up the stored
 *   subscription and calls `.remove()`.
 *
 * This keeps legacy code from crashing while we migrate away from the old API.
 */

// Only apply the patch if the method is missing
if (typeof (BackHandler as any).removeEventListener !== 'function') {
  // Map<handlerFn, subscription>
  const registry = new Map<(...args: any[]) => any, { remove: () => void }>();

  const originalAdd = BackHandler.addEventListener.bind(BackHandler);

  (BackHandler as any).addEventListener = (eventName: string, handler: (...args: any[]) => boolean | void) => {
    const subscription = originalAdd(eventName, handler);
    registry.set(handler, subscription);
    return subscription as any;
  };

  (BackHandler as any).removeEventListener = (_eventName: string, handler: (...args: any[]) => boolean | void) => {
    const subscription = registry.get(handler);
    if (subscription && typeof subscription.remove === 'function') {
      subscription.remove();
      registry.delete(handler);
    }
  };
}
